module.exports = __webpack_public_path__ + "static/media/Defense.057635de.svg";